import { load_choice } from '../smart_bps/choice/utils'

export function collectChoiceNamesFromAttrs(attrs, extra = []) {
  const names = new Set()
  ;(extra || []).forEach((name) => {
    if (name) names.add(name)
  })
  if (!attrs || typeof attrs !== 'object') return [...names]

  for (const attr of Object.values(attrs)) {
    if (!attr || typeof attr !== 'object') continue
    if (attr.choice_name) names.add(attr.choice_name)
    const inner = attr.inner_attrs
    if (inner && typeof inner === 'object') {
      for (const item of Object.values(inner)) {
        if (item?.choice_name) names.add(item.choice_name)
      }
    }
  }
  return [...names]
}

export function preloadFormChoices(attrs, extra) {
  collectChoiceNamesFromAttrs(attrs, extra).forEach((name) => load_choice(name))
}
